import {getUserPaymentMethodsQuery} from './get-payment-methods'
import {getUserQuery} from './get-user'
import {getUserDataByEmailQuery} from './get-user-data-by-email'
import {getLocationQuery} from './get-user-location'

export const UserQueries = {
  getUserQuery,
  getLocationQuery,
  getUserDataByEmailQuery,
  getUserPaymentMethodsQuery,
}
